import { render, staticRenderFns } from "./VestingDocumentDropoffForm.vue?vue&type=template&id=31f1f92e"
import script from "./VestingDocumentDropoffForm.vue?vue&type=script&lang=js"
export * from "./VestingDocumentDropoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports